import React from "react";
import EconoJournalLogo from "../EconoJournalLogo";

function EmissionHeader({ language }) {
  const t = {
    EN: {
      title: "Emissions Form",
      subtitle:
        "This information will be used to calculate the event's greenhouse gas emissions and generate a report.",
    },
    ES: {
      title: "Formulario de emisiones",
      subtitle:
        "Esta información será utilizada para calcular las emisiones de Gases de Efecto Invernadero del evento y generar un reporte.",
    },
  };

  return (
    <>
      <div className="flexBetween">
        <EconoJournalLogo className="logoECJ" />
        <img
          className="logoSvant"
          src="/img/svant-logo.svg"
          alt="Svant Measure and Act"
        />
      </div>

      <h2>{t[language].title}</h2>
      <h4>{t[language].subtitle}</h4>
    </>
  );
}

export default EmissionHeader;
